/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import WebGLRenderGraph from "App/render/webgl/render_graph";
import {logError} from "App/debug";
import Shader from "App/render/webgl/shaders/shader";
import IScene from "js_interface/src/scene_interface";

export default 
class Factory {
    private static registeredShaders: any = {};

    public static register(aClass: any) {
        Factory.registeredShaders[aClass.TypeName] = aClass;
    }

    public static create(aClass: any, aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): Shader {
        let registeredClass = Factory.registeredShaders[aClass.TypeName];
        if (registeredClass === undefined) {
            logError("Try to call Factory.create on undefined type " + aClass.TypeName);
        }

        let instance = registeredClass.create(aSceneAPI, aRenderGraph);
        instance._typeName = aClass.TypeName;
        return instance;
    }

    public static createShaders(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): any {
        let shaders = {};
        for (let key in Factory.registeredShaders) {
            shaders[key] = Factory.create(Factory.registeredShaders[key], aSceneAPI, aRenderGraph);
        }

        return shaders;
    }
}
